const CACHE: Record<string, Promise<unknown>> = {}

export function getCache(key: string): Promise<unknown> | undefined {
  return CACHE[key]
}

export function setCache(key: string, value: Promise<unknown>): void {
  CACHE[key] = value
}

export function removeRequest(key: string): void {
  delete CACHE[key]
}
